import React from 'react';

class GoogleDriveDoc extends React.Component {
    render() {
        const { entityKey, contentState, children } = this.props;
        const { webViewLink: url, iconLink } = contentState.getEntity(entityKey).getData();

        const img = iconLink || 'img/icons/google-drive-icon.png';
        const style = {
            backgroundImage: `url(${img})`,
        };

        return (
            <a href={url} style={style} className="google-drive-reference" target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        );
    }
}

export default GoogleDriveDoc;
